import { useEffect, useState } from "react";
import { Mail, Phone, MessageCircle, Clock, HelpCircle } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

export default function Help() {
  const { t } = useLang();
  const [help, setHelp] = useState(null);

  useEffect(() => {
    api("/help").then(setHelp).catch(() => setHelp({ faq: [] }));
  }, []);

  return (
    <div data-testid="help-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-700/10 text-teal-700">
          <HelpCircle className="h-6 w-6" />
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{t("help_t")}</h1>
      </div>

      {help && (help.email || help.phone || help.whatsapp || help.hours) && (
        <div data-testid="help-contact" className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-700">
            {help.email && (
              <a data-testid="help-email" href={`mailto:${help.email}`} className="flex items-center gap-2 hover:text-teal-700">
                <Mail className="h-4 w-4 text-teal-600" /> {help.email}
              </a>
            )}
            {help.phone && (
              <a data-testid="help-phone" href={`tel:${help.phone}`} className="flex items-center gap-2 hover:text-teal-700">
                <Phone className="h-4 w-4 text-teal-600" /> {help.phone}
              </a>
            )}
            {help.whatsapp && (
              <a data-testid="help-whatsapp" href={`https://wa.me/${help.whatsapp.replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-teal-700">
                <MessageCircle className="h-4 w-4 text-teal-600" /> {help.whatsapp}
              </a>
            )}
            {help.hours && (
              <span data-testid="help-hours" className="flex items-center gap-2 text-slate-500">
                <Clock className="h-4 w-4 text-teal-600" /> {t("hours")}: {help.hours}
              </span>
            )}
          </div>
        </div>
      )}

      <div className="mt-8 space-y-3">
        {(help?.faq || []).map((f, i) => (
          <details
            key={i}
            data-testid={`faq-item-${i}`}
            className="group rounded-2xl border border-slate-200 bg-white px-5 py-4 open:border-teal-300"
          >
            <summary className="cursor-pointer list-none font-heading font-semibold text-slate-900 flex items-center justify-between">
              {f.q}
              <span className="text-teal-600 transition-transform group-open:rotate-45 text-xl leading-none">+</span>
            </summary>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
      {help && (help.faq || []).length === 0 && (
        <p data-testid="help-empty" className="mt-10 text-center text-sm text-slate-500">—</p>
      )}
    </div>
  );
}
